import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const ConversionPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Marca que a conversão já foi registrada
    sessionStorage.setItem('conversion_tracked', 'true');
    
    // Dispara evento para Google Ads (gtag)
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17954212675/NNiICK2PtpAcEMOWnvFC',
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#073A40] to-[#06323B] flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 sm:p-12 text-center">
        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="text-green-600" size={48} />
        </div>
        
        <h1 className="text-3xl sm:text-4xl font-bold text-[#073A40] mb-4">
          Obrigado pelo Contato!
        </h1>
        
        <p className="text-lg sm:text-xl text-[#06323B] mb-6">
          Você está sendo redirecionado para o WhatsApp da engenheira Maria Clara Franceschini.
        </p>
        
        <div className="bg-[#F2F2F2] rounded-lg p-6 mb-8">
          <p className="text-base text-[#073A40]">
            <strong>Atenção:</strong> Se o WhatsApp não abrir automaticamente, clique no botão abaixo.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            asChild
            size="lg"
            className="bg-[#25D366] hover:bg-[#20BA5A] text-white font-bold"
          >
            <a 
              href="https://wa.me/5584994054759?text=Olá!%20Vim%20pelo%20site%20e%20gostaria%20de%20solicitar%20um%20orçamento."
              target="_blank"
              rel="noopener noreferrer"
            >
              Abrir WhatsApp
            </a>
          </Button>

          <Button 
            variant="outline"
            size="lg"
            onClick={() => navigate('/')}
            className="border-2 border-[#073A40] text-[#073A40] hover:bg-[#073A40] hover:text-white"
          >
            <ArrowLeft className="mr-2" size={20} />
            Voltar ao Site
          </Button>
        </div>

        <p className="text-sm text-[#A69076] mt-8">
          Atendimento imediato durante horário comercial
        </p>
      </div>
    </div>
  );
};

export default ConversionPage;
